export default "Choose how meal break surcharges are triggered.\n\n<INJECT:meal_trigger_mode/>\n"